import React, { memo, useCallback, useMemo } from 'react';
import { Button, Popover, Text, useTheme } from '@Sage/hoi-poi-ui';

import {
    DEV_ENVIRONMENTS,
    getDevEnvironmentOverride,
    hasDevEnvironmentOverride,
    isDevEnvironmentSwitcherEnabled,
    setDevEnvironment,
} from './environments';

import './styles.scss';

const DevPopUp = memo(() => {
    const theme = useTheme();
    const overrideEnvironment = useMemo(() => getDevEnvironmentOverride(), []);
    const hasOverride = useMemo(() => hasDevEnvironmentOverride(), []);

    const handleSetEnvironment = useCallback(
        (name) => {
            // Clicking the active override deselects it and returns to the deploy default
            if (overrideEnvironment && name === overrideEnvironment) {
                setDevEnvironment('');
                window.location.reload();
                return;
            }

            setDevEnvironment(name);
            window.location.reload();
        },
        [overrideEnvironment],
    );

    const PopUpContent = useMemo(() => {
        return (
            <div className="fm-dev__popup__buttons">
                {DEV_ENVIRONMENTS.map((env) => (
                    <Button
                        key={env.name}
                        size="small"
                        type={env.name === overrideEnvironment ? 'primary' : 'secondary'}
                        onClick={() => handleSetEnvironment(env.name)}
                    >
                        {env.name}
                    </Button>
                ))}
            </div>
        );
    }, [overrideEnvironment, handleSetEnvironment]);

    if (!isDevEnvironmentSwitcherEnabled()) return null;

    return (
        <div className="fm-dev__popup">
            <Popover placement="top" content={PopUpContent}>
                <div
                    className={`fm-dev__popup__tag${
                        hasOverride ? ' fm-dev__popup__tag--override' : ''
                    }`}
                >
                    {hasOverride && (
                        <>
                            <span className="fm-dev__popup__sparkle" />
                            <span className="fm-dev__popup__sparkle" />
                            <span className="fm-dev__popup__sparkle" />
                            <span className="fm-dev__popup__sparkle" />
                            <span className="fm-dev__popup__sparkle" />
                            <span className="fm-dev__popup__sparkle" />
                            <span className="fm-dev__popup__sparkle" />
                            <span className="fm-dev__popup__sparkle" />
                            <span className="fm-dev__popup__sparkle" />
                            <span className="fm-dev__popup__sparkle" />
                        </>
                    )}
                    <Text color={theme.colors.primary.white}>ENVIRONMENTS</Text>
                </div>
            </Popover>
        </div>
    );
});

export default DevPopUp;
